import axios from "axios";
import axiosInstance from "@/services/https/global";
import CONFIG from "../config";

const baseUrl = `${CONFIG.BASE_URL}/auth-service/api/v1`;

export const getMerchantId = async ({ userId }) => {
  try {
    const response = await axiosInstance.get(
      `${baseUrl}/admin/users/corporate-profile/merchantID/${userId}`,
    );
    return response.data?.merchantID ?? null;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      if (error.response?.status === 400) {
        return null;
      }
      throw error.response?.data || error;
    }
    throw error;
  }
};

export const toggleUser = async ({ userId }) => {
  try {
    const response = await axiosInstance.get(
      `${baseUrl}/admin/users/activation-toggle?userId=${userId}`,
    );
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      if (error.response?.status === 400) {
        return error.response.data;
      }
      throw error.response?.data || error;
    }
    throw new Error("An unexpected error occurred");
  }
};

export const updateUser = async ({ userId, updateData }) => {
  try {
    const response = await axiosInstance.put(
      `${baseUrl}/admin/update-profile/${userId}`,
      updateData,
    );
    return response.data.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      if (error.response?.status === 400) {
        return error.response.data;
      }
      throw error.response?.data || error;
    }
    throw new Error("An unexpected error occurred");
  }
};

export const createAdminUser = async (payload) => {
  try {
    const response = await axiosInstance.post(
      `${baseUrl}/admin/users/create-private`,
      payload,
    );
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      throw error.response?.data || error;
    }
    throw new Error("An unexpected error occurred");
  }
};

export const updateAdminUser = async (payload) => {
  try {
    const response = await axiosInstance.patch(
      `${baseUrl}/admin/user/update-admin-profile`,
      payload,
    );
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      throw error.response?.data || error;
    }
    throw new Error("An unexpected error occurred");
  }
};

export const deleteAdminUser = async (userId) => {
  try {
    const response = await axiosInstance.delete(
      `${baseUrl}/admin/user/${userId}`,
    );
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      throw error.response?.data || error;
    }
    throw new Error("An unexpected error occurred");
  }
};

export const toggle2Fa = async (userId) => {
  try {
    const response = await axiosInstance.post(
      `${baseUrl}/auth/toggle-2fa?userId=${userId}`,
      {},
    );
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      throw error.response?.data || error;
    }
    throw new Error("An unexpected error occurred");
  }
};

export const changePassword = async (payload) => {
  try {
    const response = await axiosInstance.post(
      `${baseUrl}/password/change`,
      payload,
    );
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      throw error.response?.data || error;
    }
    throw new Error("An unexpected error occurred");
  }
};

export const getAdminUser = async () => {
  try {
    const response = await axiosInstance.get(
      `${baseUrl}/admin/user/fetch-profile`,
    );
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      throw error.response?.data || error;
    }
    throw new Error("An unexpected error occurred");
  }
};

export const getUserByUserId = async ({ userId }) => {
  try {
    const response = await axiosInstance.get(`${baseUrl}/profile/${userId}`);
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      throw error.response?.data || error;
    }
    throw new Error("An unexpected error occurred");
  }
};

// export const getUserByUserId = async ({ userId }) => {
//   try {
//     const response = await axiosInstance.get(`${baseUrl}/user/${userId}`);
//     return response.data;
//   } catch (error) {
//     if (axios.isAxiosError(error)) {
//       throw error.response?.data || error;
//     }
//     throw new Error("An unexpected error occurred");
//   }
// };

export const getTotalInactiveUsers = async () => {
  try {
    const response = await axiosInstance.get(
      `${baseUrl}/dashboard/in-active-users`,
    );
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      throw error.response?.data || error;
    }
    throw new Error("An unexpected error occurred");
  }
};

export const getTotalActiveUsers = async () => {
  try {
    const response = await axiosInstance.get(
      `${baseUrl}/dashboard/active-users`,
    );
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      throw error.response?.data || error;
    }
    throw new Error("An unexpected error occurred");
  }
};

export const getTotalUsers = async () => {
  try {
    const response = await axiosInstance.get(
      `${baseUrl}/dashboard/total-registered-users`,
    );
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      throw error.response?.data || error;
    }
    throw new Error("An unexpected error occurred");
  }
};

export const getUsers = async (params = {}) => {
  const queryParams = {};

  if (params.page !== undefined) queryParams.page = params.page;
  if (params.size !== undefined) queryParams.size = params.size;
  if (params.corporate !== undefined) queryParams.corporate = params.corporate;
  if (params.isActive !== undefined) queryParams.isActive = params.isActive;
  if (params.businessType !== undefined)
    queryParams.businessType = params.businessType;
  if (params.search && params.search.trim())
    queryParams.search = params.search.trim();

  try {
    const response = await axiosInstance.get(
      `${baseUrl}/admin/users/corporate-users`,
      {
        params: queryParams,
      },
    );
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      throw error.response?.data || error;
    }
    throw new Error("An unexpected error occurred");
  }
};
